import { createContext } from 'react'
import { CASE_STATUS_FLOW } from '@/constants'
import { useReferral } from './useReferral'

export type ReferralContextProps = ReturnType<typeof useReferral>

export const ReferralContext = createContext<ReferralContextProps>({
  caseEntry: {
    attorney: {
      attorney_id: '',
      avatar: null,
      first_name: '',
      is_vetted: false,
      last_name: '',
      membership_type: '',
      organization_id: '',
      organization_name: '',
      role: '',
      user_id: '',
    },
    attorney_id: '',
    case_purchase: [],
    collaborators: [],
    created_ts: '',
    data_room: [],
    description: '',
    fee: 0,
    following: false,
    id: '',
    jurisdiction: '',
    jurisdiction_id: '',
    leads: [],
    mp_visibility: '',
    name: '',
    needs_your_attention: false,
    status: CASE_STATUS_FLOW.Available,
    type: '',
    waterfall: [],
  },
  caseParams: {
    caseMpPreferenceId: '',
    casePurchaseWithPayment: undefined,
    dataroom: [],
    isCaseOwner: false,
    isInitiatingAttorney: false,
    isPrivate: false,
    negotiations: [],
    referralType: 'proposed',
  },
  counterpart: undefined,
  counterpartInitials: '',
  isBuyerUsingCaseManager: false,
  isCaseManager: false,
  isClientContactedOptimistic: false,
  isSellerUsingCaseManager: false,
  isUserActingAsProxy: false,
  isUserSeller: false,
  noPaymentRequired: false,
  postedAtDate: new Date(),
  postedAtDateString: '',
  postedAtDateTimeString: '',
  setClientContacted: () => {},
  showUserSidePrincipal: false,
  sortedCasePurchases: [],
  statesLoading: false,
  statesMap: {},
  wasBuyerInvited: false,
})
